import { Autocomplete, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography, Grid, CircularProgress, useMediaQuery } from "@mui/material";
import React from "react";
import { serviceActivityOptions, serviceProvisionOptions, systemTypeOptions, systemFuelOptions, systemChannelOptions, systemBrandOptions, serviceIssueOptions, statusOptions } from "./_Options";
import { carBrands, ecuTypeOptions, renderEcuTypeOption, renderServiceActivityStatusOption, serviceActivityStatusOptions } from "../_Utils/AppDocuCommon";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './mui-quill-rounded.css';
import AppDocuServiceCall from '../_Utils/AppDocuServiceCall';
import SearchIcon from '@mui/icons-material/Search';
import AuthService from '../../../services/auth-service';
import notify from "devextreme/ui/notify";
import ConfirmDialog from '../_Utils/ConfirmDialog';
import { DateTypeProvider } from '../_Utils/DateTypeProvider';
import UserSearchResultTable from './UserSearchResultTable';

// Componente riutilizzabile per il form di Service Activity (Add/Edit)
class ServiceActivityDialogForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      carModelOptions: [],
      engineCodeOptions: [],
      brandMachines: [],
      brandInput: props.itemData.car_brand || '',
      loadingModels: false,
      // Stato per dialog ricerca user
      userSearchDialogOpen: false,
      userSearchResults: [],
      userSearchLoading: false,
      userSearchValue: '',
      userSearchDebounceTimeout: null,
      // Stato per dialog conferma uscita
      confirmDialogOpen: false,
      pendingClose: false,
      initialData: JSON.stringify(props.itemData),
    };
    this.brandTimeout = null;
  }
  
  componentDidMount() {   
  }

  componentDidUpdate(prevProps, prevState) {
    // Sincronizza brandInput con la prop se cambia il valore da fuori
    if (prevProps.itemData.car_brand !== this.props.itemData.car_brand) {
      this.setState({ brandInput: this.props.itemData.car_brand || '' });
    }
    // Aggiorna engineCodeOptions se cambia il modello o la lista delle macchine
    if (
      prevProps.itemData.car_model !== this.props.itemData.car_model ||
      this.state.brandMachines !== prevState.brandMachines
    ) {
      const { car_model } = this.props.itemData;
      const { brandMachines } = this.state;
      if (car_model && brandMachines && brandMachines.length > 0) {
        const codes = brandMachines
          .filter(m => m.model === car_model && m.engine_code)
          .map(m => m.engine_code)
          .filter((code, idx, arr) => code && arr.indexOf(code) === idx);
        this.setState({ engineCodeOptions: codes });
      } else {
        this.setState({ engineCodeOptions: [] });
      }
    }
  }

  componentWillUnmount() {
    if (this.brandTimeout) clearTimeout(this.brandTimeout);
    if (this.state.userSearchDebounceTimeout) clearTimeout(this.state.userSearchDebounceTimeout);
  }

  handleBrandInputChange = (event, newInputValue) => {
    const { editMode, onChange, itemData } = this.props;
    if (newInputValue !== this.state.brandInput) {
      this.setState({
        brandInput: newInputValue
      });
      // Aggiorna subito il valore nel parent
      onChange({ ...itemData, car_brand: newInputValue, car_model: '', car_engine_code: '' });
      if (!editMode) {
        if (this.brandTimeout) clearTimeout(this.brandTimeout);
        this.setState({ loadingModels: true });
        this.brandTimeout = setTimeout(() => {
          AppDocuServiceCall.listVehicles({ brand: newInputValue })
            .then(res => {
              const data = Array.isArray(res.data) ? res.data : (res.data.machines || []);
              const seen = new Set();
              const models = Array.isArray(data)
                ? data.map(m => m.model).filter(model => {
                    if (!model || seen.has(model)) return false;
                    seen.add(model);
                    return true;
                  })
                : [];
              this.setState({
                brandMachines: data,
                carModelOptions: models,
                loadingModels: false
              });
            })
            .catch(() => {
              this.setState({ carModelOptions: [], brandMachines: [], loadingModels: false });
            });
        }, 500);
      }
    } 
  };

  handleOpenUserSearchDialog = () => {
    this.setState({ userSearchDialogOpen: true, userSearchValue: '', userSearchResults: [] });
  };

  handleCloseUserSearchDialog = () => {
    this.setState({ userSearchDialogOpen: false, userSearchResults: [] });
  };
  
  handleUserSearch = async () => {
    const value = this.state.userSearchValue || '';
    if (!value.trim()) return;
    this.setState({ userSearchLoading: true, userSearchResults: [] });
    try {
      const res = await AuthService.searchServiceUsers(value);
      if (!res || res.is_valid === false) {
        notify(res.message || 'Error searching users', 'error');
        this.setState({ userSearchResults: [], userSearchLoading: false });
      } else {
        const data = res.rows
        console.log('User search results:', data);
        this.setState({ userSearchResults: data, userSearchLoading: false });
      }
    } catch (e) {
      this.setState({ userSearchResults: [], userSearchLoading: false });
    }
  };

  handleSelectUserFromSearch = (user) => {
    const { onChange, itemData } = this.props;
    onChange({ ...itemData, username: user.username });
    this.setState({ userSearchDialogOpen: false, userSearchResults: [] });
  };

  handleUserSearchInputChange = (value) => {
    this.setState({ userSearchValue: value });
    if (!value || !value.trim()) {
      this.setState({ userSearchResults: [] });
    }
    if (this.state.userSearchDebounceTimeout) {
      clearTimeout(this.state.userSearchDebounceTimeout);
    }
    this.setState({
      userSearchDebounceTimeout: setTimeout(() => {
        if (value && value.trim()) {
          this.handleUserSearch();
        }
      }, 800)
    });
  };

  // Funzione per verificare se i dati sono cambiati
  isDataChanged = () => {
    const { itemData } = this.props;
    return JSON.stringify(itemData) !== this.state.initialData;
  };

  // Override della chiusura: mostra dialog se dati cambiati
  handleRequestClose = () => {
    if (this.isDataChanged()) {
      this.setState({ confirmDialogOpen: true, pendingClose: true });
    } else {
      this.props.onClose();
    }
  };

  handleConfirmClose = () => {
    this.setState({ confirmDialogOpen: false, pendingClose: false }, () => {
      this.props.onClose();
    });
  };

  handleCancelClose = () => {
    this.setState({ confirmDialogOpen: false, pendingClose: false });
  };

  render() {
    const { itemData, onChange, loading, onSubmit, onClose, showUsername, title, submitLabel, disabled, open, editMode } = this.props;
    const { carModelOptions, engineCodeOptions, brandInput, loadingModels, userSearchDialogOpen, userSearchResults, userSearchLoading } = this.state;
    return (
      <>
        <Dialog open={open} onClose={this.handleRequestClose} maxWidth="xl" fullWidth>
          <DialogTitle>{title}</DialogTitle>
          <DialogContent sx={{ overflowY: 'auto', overflow: 'visible' }}>
            <Grid container spacing={3} direction='row'>
              <Grid item xs={12} md={5}>
                {showUsername && (
                  <>
                    <Typography variant="h6" sx={{ mt: 0, fontWeight: 'bold', color: '#1976d2', fontSize: '1.0rem' }}>User</Typography>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <TextField size="small" fullWidth label="Username" value={itemData.username || ''} onChange={e => onChange({ ...itemData, username: e.target.value })} sx={{ mb: 1 }} />
                      <Button onClick={this.handleOpenUserSearchDialog} sx={{ minWidth: 0, mb: 1 }}><SearchIcon /></Button>
                    </div>
                  </>
                )}



                <Typography variant="h6" sx={{ mt: 0, fontWeight: 'bold', color: '#1976d2', fontSize: '1.0rem' }}>Activity</Typography>
                <Grid container spacing={1} sx={{ mb: 1 }}>
                  <Grid item xs={12} md={6}>
                    <Autocomplete
                      freeSolo
                      options={serviceActivityOptions}
                      value={itemData.service_activity || ''}
                      onInputChange={(event, newInputValue) => onChange({ ...itemData, service_activity: newInputValue })}
                      renderInput={(params) => (<TextField {...params} size="small" fullWidth label="Type" />)}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Autocomplete
                      freeSolo
                      options={serviceProvisionOptions}
                      getOptionLabel={opt => (typeof opt === 'string' ? opt : opt.name)}
                      value={serviceProvisionOptions.find(opt => opt.name === itemData.service_provision) || itemData.service_provision || ''}
                      onInputChange={(event, newInputValue) => onChange({ ...itemData, service_provision: newInputValue })}
                      onChange={(event, newValue) => {
                        if (typeof newValue === 'string') {
                          onChange({ ...itemData, service_provision: newValue });
                        } else if (newValue && newValue.name) {
                          onChange({ ...itemData, service_provision: newValue.name });
                        } else {
                          onChange({ ...itemData, service_provision: '' });
                        }
                      }}
                      renderOption={(props, option) => (
                        <li {...props} style={{ display: 'flex', alignItems: 'center' }}>
                          {option.icon && React.createElement(option.icon, { style: { color: option.color, marginRight: 8 } })}
                          {option.label || option.name}
                        </li>
                      )}
                      renderInput={(params) => (<TextField {...params} size="small" fullWidth label="Provision" />)}
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={1} sx={{ mb: 1 }}>
                  <Grid item xs={12} md={6}>
                    <Autocomplete
                      freeSolo
                      options={serviceIssueOptions}
                      value={itemData.service_issue || ''}
                      onInputChange={(event, newInputValue) => onChange({ ...itemData, service_issue: newInputValue })}
                      renderInput={(params) => (<TextField {...params} size="small" fullWidth label="Issue" />)}
                    />
                  </Grid>
                  <Grid item xs={6} md={3}>
                    <Autocomplete
                      freeSolo
                      options={serviceActivityStatusOptions.map(opt => opt.name)}
                      value={itemData.status || ''}
                      onInputChange={(_, newValue) => onChange({ ...itemData, status: newValue })}
                      renderOption={renderServiceActivityStatusOption}
                      renderInput={(params) => (<TextField {...params} size="small" fullWidth label="Status" disabled={disabled} />)}
                    />
                  </Grid>
                  <Grid item xs={6} md={3}>
                    <TextField
                      size="small"
                      fullWidth
                      label="Effort (minutes)"
                      type="number"
                      value={itemData.service_time || '0'}
                      onChange={e => {
                        const val = e.target.value;
                        if (/^\d*$/.test(val)) onChange({ ...itemData, service_time: val });
                      }}
                      InputProps={{ endAdornment: <span style={{ marginLeft: 4 }}></span>, inputProps: { min: 0 } }}
                    />
                  </Grid>
                </Grid>



                <Typography variant="h6" sx={{ mt: 0, fontWeight: 'bold', color: '#1976d2', fontSize: '1.0rem', display: 'flex', alignItems: 'center' }}>
                  Vehicle
                  {editMode && loadingModels && (
                    <span style={{ marginLeft: 8 }}><CircularProgress size={18} /></span>
                  )}
                </Typography>
                <Grid container spacing={1} sx={{ mb: 1 }}>
                  <Grid item xs={12} md={4}>
                    <Autocomplete
                      fullWidth
                      options={carBrands}
                      value={itemData.car_brand || ''}
                      onInputChange={this.handleBrandInputChange}
                      inputValue={brandInput}
                      renderInput={(params) => <TextField {...params} size="small" label="Brand" />}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Autocomplete
                      freeSolo
                      options={carModelOptions}
                      value={itemData.car_model}
                      onInputChange={(event, newInputValue) => onChange({ ...itemData, car_model: newInputValue })}
                      isOptionEqualToValue={(option, value) => option === value}
                      renderInput={(params) => <TextField {...params} size="small" label="Model" />}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Autocomplete
                      freeSolo
                      options={engineCodeOptions}
                      value={itemData.car_engine_code}
                      onInputChange={(event, newInputValue) => onChange({ ...itemData, car_engine_code: newInputValue })}
                      isOptionEqualToValue={(option, value) => option === value}
                      renderInput={(params) => <TextField {...params} size="small" label="Engine Code" />}
                    />
                  </Grid>
                </Grid>
                <TextField size="small" fullWidth label="Notes" value={itemData.car_notes || ''} onChange={e => onChange({ ...itemData, car_notes: e.target.value })} sx={{ mb: 1 }} />
                
                
                
                <Typography variant="h6" sx={{ mt: 0, fontWeight: 'bold', color: '#1976d2', fontSize: '1.0rem' }}>System</Typography>
                <Grid container spacing={1} sx={{ mb: 1 }}>
                  <Grid item xs={12} md={4}>
                    <Autocomplete
                      freeSolo
                      options={systemTypeOptions}
                      value={itemData.system_type || ''}
                      onInputChange={(event, newInputValue) => onChange({ ...itemData, system_type: newInputValue })}
                      renderInput={(params) => (<TextField {...params} size="small" fullWidth label="Type" />)}
                    />
                  </Grid>
                  <Grid item xs={12} md={8}>
                    <Autocomplete
                      freeSolo
                      fullWidth
                      options={ecuTypeOptions.map(opt => opt.name)}
                      value={itemData.ecu_type || ''}
                      onChange={(_, newValue) => onChange({ ...itemData, ecu_type: newValue || '' })}
                      onInputChange={(_, newInputValue) => onChange({ ...itemData, ecu_type: newInputValue })}
                      renderOption={renderEcuTypeOption}
                      renderInput={(params) => <TextField {...params} size="small" label="ECU" disabled={disabled} />}
                      disableClearable
                      autoHighlight
                    />
                  </Grid>                
                </Grid>
                <Grid container spacing={1} sx={{ mb: 1 }}>
                  <Grid item xs={6} md={4}>
                    <Autocomplete
                      freeSolo
                      options={systemFuelOptions}
                      value={itemData.system_fuel || ''}
                      onInputChange={(event, newInputValue) => onChange({ ...itemData, system_fuel: newInputValue })}
                      renderInput={(params) => (<TextField {...params} size="small" fullWidth label="Fuel" />)}
                    />
                  </Grid>
                  <Grid item xs={6} md={4}>
                    <Autocomplete
                      freeSolo
                      options={systemChannelOptions}
                      value={itemData.system_channel || ''}
                      onInputChange={(event, newInputValue) => onChange({ ...itemData, system_channel: newInputValue })}
                      renderInput={(params) => (<TextField {...params} size="small" fullWidth label="Channel" />)}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Autocomplete
                      freeSolo
                      options={systemBrandOptions}
                      value={itemData.system_brand || ''}
                      onInputChange={(event, newInputValue) => onChange({ ...itemData, system_brand: newInputValue })}
                      renderInput={(params) => (<TextField {...params} size="small" fullWidth label="Brand" />)}
                    />
                  </Grid>
                  
                  
                </Grid>
              </Grid>


              <Grid item xs={12} md={7}>
                <Typography variant="h6" sx={{ mt: 0, fontWeight: 'bold', color: '#1976d2', fontSize: '1.0rem' }}>Description</Typography>
                <ReactQuill
                  theme="snow"
                  value={itemData.service_desc || ''}
                  onChange={val => onChange({ ...itemData, service_desc: val })}
                  style={{ 
                    background: '#fff', 
                    marginBottom: 10, 
                    // borderRadius: 8, border: '1px solid #c4c4c4' 
                  }}
                  className="mui-quill-rounded"
                />
                <Typography variant="h6" sx={{ mt: 0, fontWeight: 'bold', color: '#1976d2', fontSize: '1.0rem' }}>Solution</Typography>
                <ReactQuill
                  theme="snow"
                  value={itemData.service_solution || ''}
                  onChange={val => onChange({ ...itemData, service_solution: val })}
                  style={{ 
                    background: '#fff', 
                    marginBottom: 10, 
                    // borderRadius: 8, border: '1px solid #c4c4c4' 
                  }}
                  className="mui-quill-rounded"
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={onClose}>Cancel</Button>
            <Button onClick={onSubmit} color="primary" disabled={loading || disabled}>
              {submitLabel}
            </Button>
          </DialogActions>




          
          {/* Dialog ricerca utente semplice */}
          <Dialog open={userSearchDialogOpen} onClose={this.handleCloseUserSearchDialog} maxWidth="xl" fullWidth>
            <DialogContent>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                    <TextField
                      size="small"
                      fullWidth
                      label="Search users (company, name, country, email, username, LR user code)"
                      value={this.state.userSearchValue || ''}
                      onChange={e => this.handleUserSearchInputChange(e.target.value)}
                      autoFocus
                    />
                    <Button onClick={this.handleCloseUserSearchDialog} variant="contained" sx={{ minWidth: 100, height: '40px', alignSelf: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 0, fontWeight: 'bold', fontSize: '1rem' }}>
                      CLOSE
                    </Button>
                  </div>
                </Grid>
              </Grid>
              {userSearchLoading && <CircularProgress size={24} sx={{ ml: 2, mt: 2 }} />}
              <UserSearchResultTable userSearchResults={userSearchResults} onSelectUser={this.handleSelectUserFromSearch} />
            </DialogContent>
          </Dialog>
        </Dialog>
        <ConfirmDialog
          open={this.state.confirmDialogOpen}
          onConfirm={this.handleConfirmClose}
          onCancel={this.handleCancelClose}
        />
      </>
    );
  }
}

export default ServiceActivityDialogForm;
